import * as React from "react"
import type { SVGProps } from "react"
const SvgTagTrigger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.15 22a2 2 0 0 1-1.43-.6l-7.15-7.15q-.3-.3-.43-.66a2 2 0 0 1 0-1.49q.13-.37.43-.67l7.8-7.83q.28-.27.66-.44A2 2 0 0 1 11.8 3h7.18q.83 0 1.4.59.6.59.6 1.41v7.18a2 2 0 0 1-.09.56 6 6 0 0 0-1.91-.66V5h-7.15L4 12.85 11.15 20l.94-.94a6 6 0 0 0 .78 2.05l-.3.29a2 2 0 0 1-1.42.6" />
    <path d="M15.48 10q.61 0 1.06-.44.44-.43.44-1.06t-.44-1.06A1.5 1.5 0 0 0 15.48 7q-.62 0-1.07.44a1.5 1.5 0 0 0-.43 1.06q0 .63.43 1.06.45.45 1.07.44m.47 9h1.55v2.2q0 .2.16.25t.29-.1l2.5-3.58a.5.5 0 0 0 .04-.5.5.5 0 0 0-.44-.27H18.5v-2.2q0-.2-.16-.25t-.29.1l-2.5 3.57a.5.5 0 0 0-.04.52.5.5 0 0 0 .44.26" />
  </svg>
)
export default SvgTagTrigger
